import React from 'react';
import { Box } from '@mantine/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableIngredientProps {
  id: string;
  children: React.ReactNode;
}

export const SortableIngredient: React.FC<SortableIngredientProps> = ({
  id,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'transform 200ms ease',
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={{
        ...style,
        position: 'relative',
      }}
    >
      {/* Invisible drag overlay covering entire component */}
      <Box
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          cursor: isDragging ? 'grabbing' : 'grab',
          touchAction: 'manipulation',
          userSelect: 'none',
          zIndex: 0,
        }}
      />

      {/* Actual ingredient editor with higher z-index for interactivity */}
      <Box style={{ position: 'relative', zIndex: 1, pointerEvents: 'none' }}>
        {children}
      </Box>
    </Box>
  );
};
